
  import {Component, Vue} from "vue-property-decorator";
  import SimpleAppTable from "@/shared/AppTable/components/SimpleAppTable.vue";
  import {IDeviceStats} from "@/modules/DeviceStats/interfaces/device-stats.interface";
  import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
  import {IApp} from "@/interfaces/app.interface";
  import {IAppState} from "@/interfaces/app-state.interface";
  import TypeCell from "@/modules/DeviceStats/components/tableCells/TypeCell.vue";
  import {isMobile} from "mobile-device-detect";
  import moment from "moment";

  @Component({
    components: {
      TypeCell,
      SimpleAppTable,
    }
  })
  export default class DeviceStatsTable extends Vue {
    isLoading: boolean = true;

    get tableProps(): IAppTable.ITableProp[] {
      let result: IAppTable.ITableProp[] = [
        {
          prop: 'type',
          label: isMobile ? 'Парковка<br>Времени назад' : 'Тип',
          propType: IApp.SortingPropType.CustomComponent,
          customComponentName: 'TypeCell',
        },
      ];

      if (isMobile) {
        result.push(...[
          { prop: 'dateString', label: 'Начало<br>Окончание', },
          { prop: 'durationCameras', label: 'Время<br>Коммент', },
        ]);
      }
      else {
        result.push(...[
          { prop: 'errCount',  label: 'Времени назад', },
          { prop: 'parkName', label: 'Парковка', },
          { prop: 'dateBeg', label: 'Начало', propType: IApp.SortingPropType.Date, dateFormat: IApp.DateFormats.PrintedDateTimeShort },
          { prop: 'dateEnd', label: 'Окончание', propType: IApp.SortingPropType.Date, dateFormat: IApp.DateFormats.PrintedDateTimeShort },
          { prop: 'duration', label: 'Время', },
          { prop: 'cameras', label: 'Примечание', },
        ]);
      }

      return result
    }
    customComponents = {
      TypeCell,
    };

    get storeState(): IAppState { return this.$store.state; }
    get loadingTable() { return this.storeState.deviceStats.loading; }

    get tableList(): IDeviceStats.IEntity[] {
      return this.storeState.deviceStats.tableData
        .sort((a, b) => a.orderId > b.orderId ? 1 : -1)
        .map((row: IDeviceStats.IEntity) => {
          let dateBeg = row.dateBeg ? moment(row.dateBeg).format(IApp.DateFormats.PrintedDateTimeShort) : '';
          let dateEnd = row.dateEnd ? moment(row.dateEnd).format(IApp.DateFormats.PrintedDateTimeShort) : '';
          let dateString = dateBeg;
          if (dateBeg) dateString += `<br>${dateEnd}`;

          let durationCameras = row.duration;
          if (row.cameras) durationCameras += `<br>${row.cameras}`;

          return {
            ...row,
            rowClass: row.errFlag ? 'error-item' : '',
            durationCameras,
            dateString,
          }
        });
    }


  }
